import React, { createContext, useState, useEffect, useContext } from 'react';

// Default theme values from tailwind.config.js
const defaultTheme = {
  primary: '#004369', // Navy Blue
  accent: '#DB1F48',  // Red
  teal: '#01949A',    // Teal
  sand: '#E5DDC8',    // Sand Dollar
};

// Create the context
export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Get theme from localStorage or use default
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('onepoint-theme');
    return savedTheme ? JSON.parse(savedTheme) : defaultTheme;
  });

  // Update localStorage when theme changes
  useEffect(() => {
    localStorage.setItem('onepoint-theme', JSON.stringify(theme));
    
    // Apply theme colors to CSS variables for runtime theming
    const root = document.documentElement;
    Object.entries(theme).forEach(([key, value]) => {
      root.style.setProperty(`--color-${key}`, value);
    });
  }, [theme]);

  // Reset to default theme
  const resetTheme = () => {
    setTheme(defaultTheme);
  };

  // Update a specific color
  const updateColor = (colorKey, newValue) => {
    setTheme(prevTheme => ({
      ...prevTheme,
      [colorKey]: newValue
    }));
  };

  return (
    <ThemeContext.Provider value={{ theme, updateColor, resetTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to use the theme context
export const useTheme = () => useContext(ThemeContext);